export default __webpack_public_path__ + "static/media/aboutus-simple-new-logo.e6da267e.svg";